
//nota : cambiati campi date senza underscore
export class Acm {
  id?: string;
  channel_id?: any;
  acm_code: string;
  acm_type_id?: any;
  description?: string;
  short_descr?: string;
  date_start?: string;
  date_end?: string;
  flg_visible?: string;
  host_code?: string;
  oper_max_num_pid?: number;
  max_num?: number;
  oper_max_value_pid?: number;
  max_value?: number;
  oper_trigger_num_pid?: number;
  oper_trigger_value_pid?: number;
  def_num?: number;
  def_value?: number;
  flg_periodic_reset?: number;
  period_reset_pid?: number;
  value_period_pid?: number;
  trigger_cluster_id?: number;
  channelDescription?: string;
  channelCode?: string;
  acmTypeDescription?: string;
  acmDescription?: string;
  acmCodeDescription?: string;
  value?: number;
  value_2?: number;
  date_pti_start?: string;
  date_pti_end?: string;
}

export class AcmHasLayout {
  id?: string;
  acm_id?: string;
  layout_id?: string;
  description_fe?: string;
  format_string?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-acm.model.ts